import { Dispatch, FC, ReactElement, SetStateAction, useMemo, useState } from "react";
import cx from 'classnames';

interface UITabProps {
	wrapperClassName: string;
	title: string;
}

export const UITab: FC<UITabProps> = ({
	wrapperClassName,
	children
}) => {
	return (
			<div className="">
				<div className={`flex justify-center items-top mt-10 ${wrapperClassName}`}>
					{children}
				</div>
			</div>
	);
}

interface UITabHeaderProps {
	title: string;
	index: number;
	selectedTab: number;
	setSelectedTab: Dispatch<SetStateAction<number>>;
}

export const UITabHeader: FC<UITabHeaderProps> = ({title, index, selectedTab, setSelectedTab}) => {
	return (
		<li className={
			cx('py-4',
				{
					'border-b-[3px] text-[#FF8200]': index === selectedTab
				}
		)}>
			<button onClick={() => setSelectedTab(index)}>
				<p className="text-[18px] leading-[20px] font-medium"> {title} </p>
			</button>
		</li>
	)
}

// interface UITabContentProps {

// }

// export const UITabContent: FC<UITabContentProps> = ({title, content}) => {
// 	return (
		
// 	)
// }

interface UITabsProps {
	wrapperClassName: string;
	switchToFirstElement?: boolean;
	children: ReactElement[];
}

const UITabs: FC<UITabsProps> = ({ wrapperClassName, switchToFirstElement, children }) => {

	const [selectedTab, setSelectedTab] = useState(0);

	useMemo(() => {
		if (switchToFirstElement) {
			setSelectedTab(0);
		}
	}, [switchToFirstElement]);


	return (
		<div className={`hidden lg:block ${wrapperClassName}`}>
			<ul className="flex gap-[30px]">
				{children.map((item, index) => {
					if(item.props.title!='')
					{
						return <UITabHeader key={index} title={item.props.title} index={index} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
					}
				}
					
				)}
			</ul>
			{children[selectedTab]}
		</div>
	)
}

export default UITabs;